/**
 * @generated SignedSource<<f1c379c14fb708de3b182749d059f90c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BookingType = "DINING" | "LESSON" | "STANDARD";
export type SlotType = "BUCKET" | "MULTI" | "QUEUE" | "SINGLE";
export type RequestBookingWizardQueryRendererQuery$variables = {
  bookingType: BookingType;
  clubSlug: string;
  currentDate?: string | null | undefined;
  players?: ReadonlyArray<string | null | undefined> | null | undefined;
  queueSlotId: string;
  slotType?: SlotType | null | undefined;
};
export type RequestBookingWizardQueryRendererQuery$data = {
  readonly club: {
    readonly " $fragmentSpreads": FragmentRefs<"BookingWizardUIHeaderFragment">;
  } | null | undefined;
  readonly currentServerTime: string;
  readonly node: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"AddPlayersStepNode" | "BookingWizardUIFooterFragment" | "RequestWizardStepContainerNode" | "useInitializeRequestBookingWizardNode">;
  } | null | undefined;
  readonly session: {
    readonly currentClientProfile: {
      readonly " $fragmentSpreads": FragmentRefs<"AddPlayersPrivateStepClientProfile" | "AddPlayersStepClientProfile" | "PreviousBookingsStepClientProfile">;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"useInitializeRequestBookingWizardSession">;
  } | null | undefined;
};
export type RequestBookingWizardQueryRendererQuery = {
  response: RequestBookingWizardQueryRendererQuery$data;
  variables: RequestBookingWizardQueryRendererQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bookingType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "clubSlug"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "currentDate"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "players"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queueSlotId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slotType"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentServerTime",
  "storageKey": null
},
v7 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "clubSlug"
  }
],
v8 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "queueSlotId"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "kind": "Variable",
  "name": "players",
  "variableName": "players"
},
v11 = [
  {
    "alias": "publicId",
    "args": null,
    "kind": "ScalarField",
    "name": "renderingKey",
    "storageKey": null
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v14 = [
  {
    "kind": "Literal",
    "name": "bookingType",
    "value": "STANDARD"
  }
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "supportsPrivate",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "supportsPublic",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "holeCount",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "singular",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "time",
  "storageKey": null
},
v22 = {
  "kind": "Literal",
  "name": "type",
  "value": [
    "REQUEST"
  ]
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v24 = {
  "alias": "standardCapacity",
  "args": (v14/*: any*/),
  "kind": "ScalarField",
  "name": "capacity",
  "storageKey": "capacity(bookingType:\"STANDARD\")"
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "usedCapacity",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "profileImage",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v30 = [
  (v9/*: any*/),
  (v26/*: any*/),
  (v27/*: any*/),
  (v28/*: any*/),
  (v29/*: any*/)
],
v31 = [
  (v9/*: any*/)
],
v32 = {
  "kind": "InlineFragment",
  "selections": (v31/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "membershipType",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
},
v34 = [
  (v22/*: any*/)
],
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "liftAt",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requestCloses",
  "storageKey": null
},
v37 = [
  (v9/*: any*/),
  (v13/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RequestConfig",
        "kind": "LinkedField",
        "name": "requestConfig",
        "plural": false,
        "selections": (v31/*: any*/),
        "storageKey": null
      }
    ],
    "type": "RequestRule",
    "abstractKey": null
  }
],
v38 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "clientCanFulfillRequests",
    "storageKey": null
  },
  (v9/*: any*/)
],
v39 = [
  (v21/*: any*/)
],
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "Request",
  "kind": "LinkedField",
  "name": "request",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "bookingRule",
      "plural": false,
      "selections": (v37/*: any*/),
      "storageKey": null
    },
    (v9/*: any*/),
    (v21/*: any*/)
  ],
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seriesIndex",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seriesCount",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "durationMins",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "dateLte",
      "variableName": "currentDate"
    },
    {
      "kind": "Variable",
      "name": "slotType",
      "variableName": "slotType"
    }
  ],
  "concreteType": null,
  "kind": "LinkedField",
  "name": "repeatableBookings",
  "plural": true,
  "selections": [
    (v13/*: any*/),
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "RoundConnection",
      "kind": "LinkedField",
      "name": "rounds",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RoundEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v13/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "player",
                  "plural": false,
                  "selections": [
                    (v13/*: any*/),
                    (v9/*: any*/),
                    (v27/*: any*/),
                    (v28/*: any*/),
                    (v29/*: any*/)
                  ],
                  "storageKey": null
                },
                (v9/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isBooking"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "requestScheduleBlockingScope",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        (v13/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "agenda",
          "plural": false,
          "selections": [
            {
              "alias": "configuredRequestRestrictions",
              "args": (v34/*: any*/),
              "concreteType": "AgendaBookingRulesConnection",
              "kind": "LinkedField",
              "name": "requestWindowBookingRules",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AgendaBookingRulesEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    (v35/*: any*/),
                    (v36/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": (v37/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "requestWindowBookingRules(type:[\"REQUEST\"])"
            },
            (v9/*: any*/),
            (v23/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "facility",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Club",
                  "kind": "LinkedField",
                  "name": "club",
                  "plural": false,
                  "selections": [
                    (v17/*: any*/),
                    (v9/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PrivateBookingPermissionSet",
                  "kind": "LinkedField",
                  "name": "privateBookingPermissionSet",
                  "plural": false,
                  "selections": (v38/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PublicBookingPermissionSet",
                  "kind": "LinkedField",
                  "name": "publicBookingPermissionSet",
                  "plural": false,
                  "selections": (v38/*: any*/),
                  "storageKey": null
                },
                (v15/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lessonsDisplayName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FacilityCopyOverrides",
                  "kind": "LinkedField",
                  "name": "copyOverrides",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NounOverride",
                      "kind": "LinkedField",
                      "name": "lesson",
                      "plural": false,
                      "selections": [
                        (v20/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Department",
                  "kind": "LinkedField",
                  "name": "department",
                  "plural": false,
                  "selections": [
                    (v15/*: any*/),
                    (v12/*: any*/),
                    (v9/*: any*/)
                  ],
                  "storageKey": null
                },
                (v12/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CourseConnection",
                  "kind": "LinkedField",
                  "name": "courses",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "count",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                (v9/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v9/*: any*/),
        {
          "kind": "TypeDiscriminator",
          "abstractKey": "__isSlot"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "configuredRequestRestrictions",
              "args": (v34/*: any*/),
              "concreteType": "SlotBookingRulesConnection",
              "kind": "LinkedField",
              "name": "requestWindowBookingRules",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SlotBookingRulesEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    (v35/*: any*/),
                    (v36/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "requestWindowBookingRules(type:[\"REQUEST\"])"
            },
            (v21/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "groupLabel",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "holeOffset",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "BookingConnection",
              "kind": "LinkedField",
              "name": "bookings",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BookingEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v13/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RoundConnection",
                          "kind": "LinkedField",
                          "name": "rounds",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "RoundEdge",
                              "kind": "LinkedField",
                              "name": "edges",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": null,
                                  "kind": "LinkedField",
                                  "name": "node",
                                  "plural": false,
                                  "selections": [
                                    (v13/*: any*/),
                                    (v9/*: any*/),
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": null,
                                      "kind": "LinkedField",
                                      "name": "player",
                                      "plural": false,
                                      "selections": [
                                        (v13/*: any*/),
                                        (v27/*: any*/),
                                        (v28/*: any*/),
                                        (v29/*: any*/),
                                        (v9/*: any*/)
                                      ],
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        (v9/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Course",
              "kind": "LinkedField",
              "name": "course",
              "plural": false,
              "selections": [
                (v12/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CourseBucket",
                  "kind": "LinkedField",
                  "name": "courseBucket",
                  "plural": false,
                  "selections": [
                    (v12/*: any*/),
                    (v9/*: any*/)
                  ],
                  "storageKey": null
                },
                (v9/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "TimeSlot",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v39/*: any*/),
          "type": "BucketTimeSlot",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v40/*: any*/),
        (v41/*: any*/),
        (v42/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeSlot",
          "kind": "LinkedField",
          "name": "fullfillableSlots",
          "plural": true,
          "selections": (v31/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SlotConnection",
          "kind": "LinkedField",
          "name": "slots",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SlotEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v13/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": (v39/*: any*/),
                      "type": "TimeSlot",
                      "abstractKey": null
                    },
                    (v9/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "startSlot",
          "plural": false,
          "selections": [
            (v15/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Agenda",
              "kind": "LinkedField",
              "name": "agenda",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Facility",
                  "kind": "LinkedField",
                  "name": "facility",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Club",
                      "kind": "LinkedField",
                      "name": "club",
                      "plural": false,
                      "selections": [
                        (v16/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v25/*: any*/),
                (v24/*: any*/)
              ],
              "type": "TimeSlot",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RoundConnection",
          "kind": "LinkedField",
          "name": "rounds",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RoundEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "player",
                      "plural": false,
                      "selections": [
                        (v26/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CourseLayout",
                      "kind": "LinkedField",
                      "name": "courseLayout",
                      "plural": false,
                      "selections": [
                        (v19/*: any*/),
                        (v12/*: any*/),
                        (v18/*: any*/),
                        (v9/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "nonPlayingHost",
                          "storageKey": null
                        }
                      ],
                      "type": "MemberRound",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v43/*: any*/)
      ],
      "type": "StandardBooking",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v40/*: any*/),
        (v41/*: any*/),
        (v42/*: any*/),
        (v43/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "StaffProfileConnection",
          "kind": "LinkedField",
          "name": "instructors",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "StaffProfileEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StaffProfile",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v9/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "StaffUser",
                      "kind": "LinkedField",
                      "name": "user",
                      "plural": false,
                      "selections": [
                        (v26/*: any*/),
                        (v9/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "LessonBooking",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "roomName",
          "storageKey": null
        }
      ],
      "type": "DiningBooking",
      "abstractKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RequestBookingWizardQueryRendererQuery",
    "selections": [
      (v6/*: any*/),
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BookingWizardUIHeaderFragment"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AddPlayersStepNode"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useInitializeRequestBookingWizardNode"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RequestWizardStepContainerNode"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BookingWizardUIFooterFragment"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useInitializeRequestBookingWizardSession"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              {
                "args": [
                  (v10/*: any*/)
                ],
                "kind": "FragmentSpread",
                "name": "AddPlayersStepClientProfile"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AddPlayersPrivateStepClientProfile"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PreviousBookingsStepClientProfile"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "RequestBookingWizardQueryRendererQuery",
    "selections": [
      (v6/*: any*/),
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "logoImage",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          (v12/*: any*/),
          (v9/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          (v9/*: any*/),
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isNode"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v14/*: any*/),
                "kind": "ScalarField",
                "name": "capacity",
                "storageKey": "capacity(bookingType:\"STANDARD\")"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Agenda",
                "kind": "LinkedField",
                "name": "agenda",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Facility",
                    "kind": "LinkedField",
                    "name": "facility",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "memberHoldEnabled",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Club",
                        "kind": "LinkedField",
                        "name": "club",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "calendarStartDay",
                            "storageKey": null
                          },
                          (v17/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CourseConnection",
                        "kind": "LinkedField",
                        "name": "courses",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CourseEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Course",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CourseLayout",
                                    "kind": "LinkedField",
                                    "name": "defaultCourseLayout",
                                    "plural": false,
                                    "selections": [
                                      (v18/*: any*/),
                                      (v9/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v9/*: any*/),
                                  (v12/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CourseLayoutConnection",
                        "kind": "LinkedField",
                        "name": "courseLayouts",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CourseLayoutEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CourseLayout",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  (v18/*: any*/),
                                  (v19/*: any*/),
                                  (v12/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "enabled",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "memberVisible",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lessonDurationMins",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "patronRecurringRequestMaximumEndDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PrivateBookingPermissionSet",
                        "kind": "LinkedField",
                        "name": "privateBookingPermissionSet",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "membersCanMakeRecurringRequests",
                            "storageKey": null
                          },
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "maxMultipleBookings",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "multipleBookingsEnabled",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacilityCopyOverrides",
                        "kind": "LinkedField",
                        "name": "copyOverrides",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NounOverride",
                            "kind": "LinkedField",
                            "name": "course",
                            "plural": false,
                            "selections": [
                              (v20/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "plural",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 100
                          }
                        ],
                        "concreteType": "CourseBucketConnection",
                        "kind": "LinkedField",
                        "name": "courseBuckets",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CourseBucketEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CourseBucket",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  (v12/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Course",
                                    "kind": "LinkedField",
                                    "name": "courses",
                                    "plural": true,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v12/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "courseBuckets(first:100)"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000
                      }
                    ],
                    "concreteType": "TimeSlotConnection",
                    "kind": "LinkedField",
                    "name": "timeSlots",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TimeSlotEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TimeSlot",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "bookingType",
                                    "value": [
                                      "STANDARD"
                                    ]
                                  },
                                  (v22/*: any*/)
                                ],
                                "concreteType": "SlotBookingRulesConnection",
                                "kind": "LinkedField",
                                "name": "requestWindowBookingRules",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SlotBookingRulesEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v13/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "maxRequestCount",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "RequestRule",
                                            "abstractKey": null
                                          },
                                          (v9/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "requestWindowBookingRules(bookingType:[\"STANDARD\"],type:[\"REQUEST\"])"
                              },
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "availability",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "timeSlots(first:1000)"
                  },
                  (v9/*: any*/),
                  (v23/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "QueueSlot",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requirePlayerCounts",
                "storageKey": null
              },
              (v24/*: any*/),
              (v25/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Agenda",
                "kind": "LinkedField",
                "name": "agenda",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Facility",
                    "kind": "LinkedField",
                    "name": "facility",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "bookingType",
                    "variableName": "bookingType"
                  }
                ],
                "kind": "ScalarField",
                "name": "capacity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockedUntil",
                "storageKey": null
              }
            ],
            "type": "TimeSlot",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isClientProfile"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Club",
                    "kind": "LinkedField",
                    "name": "club",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "active",
                            "value": true
                          },
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 25
                          },
                          (v10/*: any*/)
                        ],
                        "concreteType": "ClientConnection",
                        "kind": "LinkedField",
                        "name": "clients",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ClientEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v13/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v30/*: any*/),
                                    "type": "Member",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v30/*: any*/),
                                    "type": "Customer",
                                    "abstractKey": null
                                  },
                                  (v32/*: any*/),
                                  (v33/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v33/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientClass",
                    "storageKey": null
                  },
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isClient"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v44/*: any*/),
                      (v9/*: any*/),
                      (v27/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberGroup",
                        "kind": "LinkedField",
                        "name": "memberGroups",
                        "plural": true,
                        "selections": (v31/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "Member",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v9/*: any*/),
                      (v44/*: any*/),
                      (v27/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/)
                    ],
                    "type": "Customer",
                    "abstractKey": null
                  },
                  (v32/*: any*/)
                ],
                "storageKey": null
              },
              (v32/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6fb22101cdacde81fd5c141ab42a25ce",
    "id": null,
    "metadata": {},
    "name": "RequestBookingWizardQueryRendererQuery",
    "operationKind": "query",
    "text": "query RequestBookingWizardQueryRendererQuery(\n  $queueSlotId: ID!\n  $currentDate: Date\n  $players: [ID]\n  $slotType: SlotType\n  $clubSlug: String!\n  $bookingType: BookingType!\n) {\n  currentServerTime\n  club(slug: $clubSlug) {\n    ...BookingWizardUIHeaderFragment\n    id\n  }\n  node(id: $queueSlotId) {\n    __typename\n    id\n    ...AddPlayersStepNode\n    ...useInitializeRequestBookingWizardNode\n    ...RequestWizardStepContainerNode\n    ...BookingWizardUIFooterFragment\n  }\n  session {\n    ...useInitializeRequestBookingWizardSession\n    currentClientProfile {\n      __typename\n      ...AddPlayersStepClientProfile_zYVbD\n      ...AddPlayersPrivateStepClientProfile\n      ...PreviousBookingsStepClientProfile\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment AddPlayersHeaderNode on Node {\n  __isNode: __typename\n  ... on TimeSlot {\n    requirePlayerCounts\n    standardCapacity: capacity(bookingType: STANDARD)\n    usedCapacity\n  }\n}\n\nfragment AddPlayersPrivateStepClientProfile on ClientProfile {\n  __isClientProfile: __typename\n  member {\n    __typename\n    clientClass\n    ... on Member {\n      id\n      firstName\n      lastName\n      profileImage {\n        publicId: renderingKey\n      }\n      memberGroups {\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment AddPlayersPrivateStepNode on Node {\n  __isNode: __typename\n  ...AddPlayersHeaderNode\n  ... on TimeSlot {\n    requirePlayerCounts\n    standardCapacity: capacity(bookingType: STANDARD)\n    usedCapacity\n    agenda {\n      facility {\n        type\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment AddPlayersStepClientProfile_zYVbD on ClientProfile {\n  __isClientProfile: __typename\n  member {\n    __typename\n    club {\n      ...AddPlayers_Clients_zYVbD\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment AddPlayersStepNode on Node {\n  __isNode: __typename\n  ... on QueueSlot {\n    __typename\n  }\n  ... on TimeSlot {\n    requirePlayerCounts\n  }\n}\n\nfragment AddPlayers_Clients_zYVbD on Club {\n  clients(first: 25, active: true, players: $players) {\n    edges {\n      node {\n        __typename\n        membershipType {\n          __typename\n          id\n        }\n        ... on Member {\n          id\n          fullName\n          firstName\n          lastName\n          profileImage {\n            publicId: renderingKey\n          }\n        }\n        ... on Customer {\n          id\n          fullName\n          firstName\n          lastName\n          profileImage {\n            publicId: renderingKey\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n  id\n}\n\nfragment BookingCard_Booking on Booking {\n  __isBooking: __typename\n  __typename\n  id\n  requestScheduleBlockingScope\n  ...useShouldPresentBookingAsLockedRequest_booking\n  rounds {\n    edges {\n      node {\n        __typename\n        id\n        player {\n          __typename\n          firstName\n          lastName\n          profileImage {\n            publicId: renderingKey\n          }\n          id\n        }\n      }\n    }\n  }\n  startSlot {\n    __typename\n    ...useHasUnpublishedRequestRestrictions_slot\n    agenda {\n      date\n      facility {\n        club {\n          supportsPublic\n          id\n        }\n        privateBookingPermissionSet {\n          clientCanFulfillRequests\n          id\n        }\n        publicBookingPermissionSet {\n          clientCanFulfillRequests\n          id\n        }\n        type\n        lessonsDisplayName\n        copyOverrides {\n          lesson {\n            singular\n          }\n        }\n        department {\n          type\n          name\n          id\n        }\n        name\n        courses {\n          count\n        }\n        id\n      }\n      id\n    }\n    ... on TimeSlot {\n      time\n      groupLabel\n      holeOffset\n      bookings {\n        edges {\n          node {\n            __typename\n            rounds {\n              edges {\n                node {\n                  __typename\n                  id\n                  player {\n                    __typename\n                    firstName\n                    lastName\n                    profileImage {\n                      publicId: renderingKey\n                    }\n                    id\n                  }\n                }\n              }\n            }\n            id\n          }\n        }\n      }\n      course {\n        name\n        courseBucket {\n          name\n          id\n        }\n        id\n      }\n    }\n    ... on BucketTimeSlot {\n      time\n    }\n    id\n  }\n  ... on StandardBooking {\n    seriesIndex\n    seriesCount\n    fullfillableSlots {\n      id\n    }\n    status\n    slots {\n      edges {\n        node {\n          __typename\n          ... on TimeSlot {\n            time\n          }\n          id\n        }\n      }\n    }\n    request {\n      time\n      id\n    }\n  }\n  ... on LessonBooking {\n    seriesIndex\n    seriesCount\n    durationMins\n    request {\n      time\n      id\n    }\n    instructors {\n      edges {\n        node {\n          id\n          user {\n            fullName\n            id\n          }\n        }\n      }\n    }\n  }\n  ... on DiningBooking {\n    roomName\n  }\n}\n\nfragment BookingWizardUIFooterFragment on Node {\n  __isNode: __typename\n  ...WizardFooter_Node\n}\n\nfragment BookingWizardUIHeaderFragment on Club {\n  ...ClubLogo_Club\n  name\n  logoImage {\n    publicId: renderingKey\n  }\n}\n\nfragment ClubLogo_Club on Club {\n  logoImage {\n    publicId: renderingKey\n  }\n}\n\nfragment PreviousBookingsListClient_3GxKZF on Client {\n  __isClient: __typename\n  ... on Member {\n    id\n    repeatableBookings(dateLte: $currentDate, slotType: $slotType) {\n      __typename\n      ... on StandardBooking {\n        id\n        startSlot {\n          __typename\n          type\n          ... on TimeSlot {\n            usedCapacity\n            standardCapacity: capacity(bookingType: STANDARD)\n          }\n          id\n        }\n        rounds {\n          edges {\n            node {\n              __typename\n              id\n              ... on MemberRound {\n                nonPlayingHost\n              }\n              player {\n                __typename\n                fullName\n                id\n              }\n            }\n          }\n        }\n      }\n      ...PreviousBookingsListItem\n      id\n    }\n  }\n  ... on Customer {\n    id\n    repeatableBookings(dateLte: $currentDate, slotType: $slotType) {\n      __typename\n      ... on StandardBooking {\n        id\n        startSlot {\n          __typename\n          type\n          ... on TimeSlot {\n            usedCapacity\n            standardCapacity: capacity(bookingType: STANDARD)\n          }\n          id\n        }\n        rounds {\n          edges {\n            node {\n              __typename\n              id\n              ... on MemberRound {\n                nonPlayingHost\n              }\n              player {\n                __typename\n                fullName\n                id\n              }\n            }\n          }\n        }\n      }\n      ...PreviousBookingsListItem\n      id\n    }\n  }\n}\n\nfragment PreviousBookingsListItem on StandardBooking {\n  id\n  durationMins\n  rounds {\n    edges {\n      node {\n        __typename\n        courseLayout {\n          code\n          name\n          holeCount\n          id\n        }\n        player {\n          __typename\n          id\n          fullName\n          firstName\n          lastName\n          profileImage {\n            publicId: renderingKey\n          }\n        }\n        id\n      }\n    }\n  }\n  startSlot {\n    __typename\n    type\n    agenda {\n      date\n      facility {\n        club {\n          supportsPrivate\n          id\n        }\n        id\n      }\n      id\n    }\n    ... on TimeSlot {\n      time\n    }\n    id\n  }\n}\n\nfragment PreviousBookingsStepClientProfile on ClientProfile {\n  __isClientProfile: __typename\n  member {\n    __typename\n    ...PreviousBookingsListClient_3GxKZF\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment PreviousBookingsStep_TimeSlot on TimeSlot {\n  capacity(bookingType: $bookingType)\n  usedCapacity\n}\n\nfragment RequestBookingDetailsStepNode on Node {\n  __isNode: __typename\n  ...RequestGroupSizeControlNode\n  ... on QueueSlot {\n    id\n    capacity(bookingType: STANDARD)\n    agenda {\n      id\n      date\n      timeSlots(first: 1000) {\n        edges {\n          node {\n            id\n            time\n            availability\n          }\n        }\n      }\n      facility {\n        club {\n          calendarStartDay\n          supportsPrivate\n          supportsPublic\n          id\n        }\n        id\n        type\n        lessonDurationMins\n        patronRecurringRequestMaximumEndDate\n        privateBookingPermissionSet {\n          membersCanMakeRecurringRequests\n          id\n        }\n        maxMultipleBookings\n        multipleBookingsEnabled\n        copyOverrides {\n          course {\n            singular\n            plural\n          }\n        }\n        courses {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        courseBuckets(first: 100) {\n          edges {\n            node {\n              id\n              name\n              courses {\n                id\n                name\n              }\n            }\n          }\n        }\n        courseLayouts {\n          edges {\n            node {\n              id\n              code\n              name\n              enabled\n              holeCount\n              memberVisible\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment RequestGroupSizeControlNode on Node {\n  __isNode: __typename\n  __typename\n  ... on QueueSlot {\n    id\n    capacity(bookingType: STANDARD)\n  }\n}\n\nfragment RequestWizardStepContainerNode on Node {\n  __isNode: __typename\n  ...RequestBookingDetailsStepNode\n  ...AddPlayersStepNode\n  ...AddPlayersPrivateStepNode\n  ...PreviousBookingsStep_TimeSlot\n}\n\nfragment WizardFooter_Node on Node {\n  __isNode: __typename\n  __typename\n  ... on TimeSlot {\n    id\n    lockedUntil\n    agenda {\n      id\n    }\n  }\n}\n\nfragment useGetRequiredWizardSteps on ClientProfile {\n  __isClientProfile: __typename\n  member {\n    __typename\n    ... on Member {\n      repeatableBookings(dateLte: $currentDate, slotType: $slotType) {\n        __typename\n        id\n        rounds {\n          edges {\n            node {\n              __typename\n              player {\n                __typename\n                id\n              }\n              id\n            }\n          }\n        }\n        ...BookingCard_Booking\n      }\n    }\n    ... on Customer {\n      id\n      repeatableBookings(dateLte: $currentDate, slotType: $slotType) {\n        __typename\n        id\n        rounds {\n          edges {\n            node {\n              __typename\n              player {\n                __typename\n                id\n              }\n              id\n            }\n          }\n        }\n        ...BookingCard_Booking\n      }\n    }\n    club {\n      clients(first: 25, active: true, players: $players) {\n        edges {\n          node {\n            __typename\n            ... on Member {\n              id\n            }\n            ... on Customer {\n              id\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n        }\n      }\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useHasUnpublishedRequestRestrictions_slot on Slot {\n  __isSlot: __typename\n  __typename\n  ... on QueueSlot {\n    agenda {\n      configuredRequestRestrictions: requestWindowBookingRules(type: [REQUEST]) {\n        edges {\n          liftAt\n          requestCloses\n        }\n      }\n      id\n    }\n  }\n  ... on TimeSlot {\n    configuredRequestRestrictions: requestWindowBookingRules(type: [REQUEST]) {\n      edges {\n        liftAt\n        requestCloses\n      }\n    }\n  }\n}\n\nfragment useInitializeRequestBookingWizardNode on Node {\n  __isNode: __typename\n  ... on QueueSlot {\n    id\n    capacity(bookingType: STANDARD)\n    agenda {\n      facility {\n        type\n        memberHoldEnabled\n        club {\n          supportsPrivate\n          id\n        }\n        courses {\n          edges {\n            node {\n              defaultCourseLayout {\n                holeCount\n                id\n              }\n              id\n            }\n          }\n        }\n        courseLayouts {\n          edges {\n            node {\n              id\n              holeCount\n            }\n          }\n        }\n        id\n      }\n      timeSlots(first: 1000) {\n        edges {\n          node {\n            time\n            requestWindowBookingRules(type: [REQUEST], bookingType: [STANDARD]) {\n              edges {\n                node {\n                  __typename\n                  ... on RequestRule {\n                    maxRequestCount\n                  }\n                  id\n                }\n              }\n            }\n            id\n          }\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment useInitializeRequestBookingWizardSession on Session {\n  currentClientProfile {\n    __typename\n    ...useGetRequiredWizardSteps\n    member {\n      __typename\n      membershipType {\n        __typename\n        id\n      }\n      ... on Member {\n        id\n        firstName\n        lastName\n        profileImage {\n          publicId: renderingKey\n        }\n      }\n      ... on Customer {\n        id\n        firstName\n        lastName\n        profileImage {\n          publicId: renderingKey\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useShouldPresentBookingAsLockedRequest_booking on Booking {\n  __isBooking: __typename\n  startSlot {\n    __typename\n    agenda {\n      configuredRequestRestrictions: requestWindowBookingRules(type: [REQUEST]) {\n        edges {\n          liftAt\n          requestCloses\n          node {\n            id\n            __typename\n            ... on RequestRule {\n              requestConfig {\n                id\n              }\n            }\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n  ... on StandardBooking {\n    request {\n      bookingRule {\n        id\n        __typename\n        ... on RequestRule {\n          requestConfig {\n            id\n          }\n        }\n      }\n      id\n    }\n  }\n  ... on LessonBooking {\n    request {\n      bookingRule {\n        id\n        __typename\n        ... on RequestRule {\n          requestConfig {\n            id\n          }\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9c09f99eab71251405c973fb110cc092";

export default node;
